function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Success_icon",
  transform: "translate(-2.25 -2.25)"
}, React.createElement("path", {
  id: "Path_1099",
  "data-name": "Path 1099",
  d: "M18,34.218l8.145,8.145L46.509,22",
  transform: "translate(0.273 0.345)",
  fill: "none",
  stroke: "#bedb48",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), React.createElement("circle", {
  id: "Ellipse_136",
  "data-name": "Ellipse 136",
  cx: 29.5,
  cy: 29.5,
  r: 29.5,
  transform: "translate(3 3)",
  fill: "none",
  stroke: "#bedb48",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}));

const SvgSuccessIcon = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60.5,
    height: 60.5,
    viewBox: "0 0 60.5 60.5",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSuccessIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success_icon.5c183902.svg";
export { ForwardRef as ReactComponent };